module.exports = __webpack_public_path__ + "img/portfolio_6.1ac9a22f.jpg";